import React from "react";

const ProfileComponent = () => {
    return (
        <div className="card">
            <div className="card-body">
                <h4>Profilo</h4>
                <ul>
                    <li><a href={"/user/account"}>Dati personali</a></li>
                    <li><a href={"/user/tickets"}>Lista ticket acquistati</a></li>
                    <li><a href={"/user/subscriptions"}>Iscrizioni</a></li>
                    <li><a href={"/logout"}>Esci</a></li>
                </ul>
            </div>
        </div>
    );
};

export default ProfileComponent;
